import videojs from 'video.js';
import { Switch } from './switch';
import { getName } from './helpers.js';

class SwitchSeasonsAndEpisodesPlugin extends videojs.getPlugin('plugin') {
	constructor(player, options) {
		super(player);

		this.switchContainer = null;

		videojs.registerComponent('SwitchSeasonsAndEpisodes', videojs.getComponent('Component'));
		videojs.registerComponent('SwitchSeasons', Switch);
		videojs.registerComponent('SwitchEpisodes', Switch);

		this.options = options;
		this.seasonsInfo = null;
		this.activeSeason = null;

		this.player.ready(() => {
			const videoTitleComponent = this.player.getDescendant(['TopPanel', 'VideoTitle']);
			if (videoTitleComponent) {
				// Использовать videoTitleComponent.hide() нельзя,
				// т.к. нижележащие элементы занимают место скрытого элемента
				// и оказываются под переключателем.
				videoTitleComponent.addClass('vjs-tp-title_visibility-hidden');
			}
		});

		this.getSeasonsInfo()
			.then((seasonsInfo) => {
				this.seasonsInfo = seasonsInfo;
				if (this.seasonsInfo.seasons.length) {
					this.addSwitches();
				}
			});
	}

	getSeasonsInfo() {
		return fetch(this.options.seasonsInfoURL)
			.then((response) => response.json())
	}

	addSwitches() {
		if (!this.player) return;
		this.switchContainer = this.player.addChild('SwitchSeasonsAndEpisodes', {
			className: 'vjs-switch-seasons-and-episodes'
		});

		this.activeSeason = this.seasonsInfo.seasons.find((season) =>
			season.episodes.some((episode) => {
				const isActive = episode.event_id.toString() === this.options.eventId;
				if (isActive) {
					this.activeEpisode = episode;
				}
				return isActive;
			})
		);

		this.addSwitchSeasons();
		this.addSwitchEpisodes();
	}

	addSwitchSeasons() {
		this.switchContainer.addChild('SwitchSeasons', {
			controlText: this.activeSeason.name,
			items: this.seasonsInfo.seasons,
			activeItem: this.activeSeason,
			onClick: (season) => {
				if (season.name === this.activeSeason.name) return;
				this.options.onChange(season.episodes[0].feed_url);
			}
		});
	}

	addSwitchEpisodes() {
		this.switchContainer.addChild('SwitchEpisodes', {
			controlText: getName(this.player, this.activeEpisode),
			items: this.activeSeason.episodes,
			activeItem: this.activeEpisode,
			onClick: (episode) => {
				if (this.activeEpisode.event_id === episode.event_id) return;
				if (!this.player.paused()) {
					this.player.pause();
				}
				this.options.onChange(episode.feed_url);
			}
		});
	}
}

videojs.registerPlugin('switchSeasonsAndEpisodes', SwitchSeasonsAndEpisodesPlugin);
